<template>
    <table-actions-menu
        position="table-action-menu--low">
        <link-table-action-button
            :url="route('main.learning-contents.show', {'learning_content': data.id})"
            :label="trans('buttons.preview')"
            target="_blank"
        >
            <inline-svg
                :url="require('../../../../images/actions/preview.svg')"
                classes="table-action-cell__icon"
            >
            </inline-svg>
        </link-table-action-button>

        <edit-button :url="route('main.learning-contents.edit', data.id)" grid="table-action-cell--grid-1of3"></edit-button>

        <delete-button
            :url="route('main.learning-contents.destroy', data.id)"
            :confirmTitle="this.trans('learning_contents.delete.title')"
            :confirmText="this.trans('learning_contents.delete.message')"
            :deleteId="data.id"
            grid="table-action-cell--grid-1of3"
        ></delete-button>
    </table-actions-menu>
</template>

<script>
    import InlineSvg from '../../../util/inlineSvg.js'
    import EditButton from '../../table_actions/table_actions_buttons/EditButton.vue';
    import DeleteButton from '../../table_actions/table_actions_buttons/DeleteButton.vue';

    export default {
        props: ['data', 'index'],

        components: {
            EditButton,
            DeleteButton,
            InlineSvg
        }
    }
</script>
